import React from 'react';
import { cn } from '@/lib/utils';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  background?: 'white' | 'light' | 'primary' | 'secondary' | 'accent';
  container?: boolean;
  spacing?: 'small' | 'medium' | 'large';
}

export function Section({
  children,
  className,
  background = 'white',
  container = true,
  spacing = 'medium',
}: SectionProps) {
  // Mapped backgrounds
  const bgMap = {
    white: 'bg-background',
    light: 'bg-background-alt',
    primary: 'bg-primary text-text-inverted',
    secondary: 'bg-secondary text-text-inverted',
    accent: 'bg-accent text-text-inverted',
  };
  
  // Mapped spacing
  const spacingMap = {
    small: 'py-8',
    medium: 'py-12',
    large: 'py-16 md:py-20',
  };
  
  return (
    <section className={cn(bgMap[background], spacingMap[spacing], className)}>
      {container ? (
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      ) : (
        children
      )}
    </section>
  );
}
